/* eslint-disable */
import template from  './vue-template.hbs';
import './index.scss';

const COMPONENT_KEY = 'bfv-search';
const HTTP_STATUS_NO_CONTENT = 204;

class Search {
  constructor(vue) {
    this.vue = vue;
    this.component = null;
    this.componentKey = COMPONENT_KEY; // Just temp
  }

  init() {
    this.component = {
      data: () => {
        return {
          componentKey: this.componentKey,
          responseData: { results: [] },
          errorOccured: false,
          dataLoadedEventKey: this.eventKey,
          wrapperClass: this,
          searchStarted: false,
          searching: false,
          placeholder: '', // needed
        }
      },
      props: {
        "data-text-search-url": String,
        "data-input-placeholder": String,
        "data-btn-text": String,
      },
      mounted: function() {
        this.placeholder = this.dataInputPlaceholder;
      },
      template,
      methods: {
        search: function(event) {
          // state handling
          this.searchStarted = true;
          this.searching = true;

          event.preventDefault();

          const searchString = document.getElementById("input-search").value;
          const url = this.dataTextSearchUrl;
          const request = url + "?query=" + searchString;

          const requests = [
            fetch(request).then(resp => {
              if (resp.status === HTTP_STATUS_NO_CONTENT) { // empty result
                return [];
              } else {
                return resp.json();
              }
            }),
          ];

          return Promise.all(requests)
            .then((dataList) => {
              const results = dataList[0];

              this.responseData = { results };
              this.searching = false;
            }, (response) => {
              this.errorOccured = true;
              console.error('failed', response);

              this.responseData = { results: [] };
              this.searching = false;
            });

        }
      },
    };

    return this;
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/templates/partials/singleFileComponents/search/search.js